const maskComposite = {
    name: "mask-composite",
    path: "mask-composite",
    title: "mask-composite",
    description: "Utilities for controlling the CSS mask-composite property.",
    value: {
        'mask-composite':{
          'mask-add': 'add',
          'mask-subtract': 'subtract',
          'mask-intersect': 'intersect',
          'mask-exclude': 'exclude',
        },
    },
    exampleData: [
        {
            "title": "mask-add, mask-intersect",
            "description": "to control how an element's masks are combined together:",
            "moreDescription": "",
            "parentClass": "grid md:grid-columns-2 gap-6 gap-y-16 !bg-none !border-0 pt-10 py-5 !mt-10",
            "example": {
                "element": "img",
                "src": [
                    {
                        "text": "mask-add",
                        "textClass": "absolute whitespace-nowrap font-sans font-regular -top-7 left-1/2 -translate-x-1/2 text-color-gray-700 dark:text-color-gray-200 text-xs italic",
                        "divClass":"h-24 w-48 mx-auto bg-image-[url(https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo)] mask-image-[radial-gradient(ellipse_25%_50%_at_30%_50%,_white_100%,transparent_100%),_radial-gradient(ellipse_25%_50%_at_70%_50%,_white_100%,transparent_100%)] bg-cover bg-center mask-add"
                    },
                    {
                        "text": "mask-subtract",
                        "textClass": "absolute whitespace-nowrap font-sans font-regular -top-7 left-1/2 -translate-x-1/2 text-color-gray-700 dark:text-color-gray-200 text-xs italic",
                        "divClass":"h-24 w-48 mx-auto bg-image-[url(https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo)] mask-image-[radial-gradient(ellipse_25%_50%_at_30%_50%,_white_100%,transparent_100%),_radial-gradient(ellipse_25%_50%_at_70%_50%,_white_100%,transparent_100%)] bg-cover bg-center mask-subtract"
                    },
                    {
                        "text": "mask-intersect",
                        "textClass": "absolute whitespace-nowrap font-sans font-regular -top-7 left-1/2 -translate-x-1/2 text-color-gray-700 dark:text-color-gray-200 text-xs italic",
                        "divClass":"h-24 w-48 mx-auto bg-image-[url(https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo)] mask-image-[radial-gradient(ellipse_25%_50%_at_30%_50%,_white_100%,transparent_100%),_radial-gradient(ellipse_25%_50%_at_70%_50%,_white_100%,transparent_100%)] bg-cover bg-center mask-intersect"
                    },
                    {
                        "text": "mask-exclude",
                        "textClass": "absolute whitespace-nowrap font-sans font-regular -top-7 left-1/2 -translate-x-1/2 text-color-gray-700 dark:text-color-gray-200 text-xs italic",
                        "divClass":"h-24 w-48 mx-auto bg-image-[url(https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo)] mask-image-[radial-gradient(ellipse_25%_50%_at_30%_50%,_white_100%,transparent_100%),_radial-gradient(ellipse_25%_50%_at_70%_50%,_white_100%,transparent_100%)] bg-cover bg-center mask-exclude"
                    },
                    
                ],
                "className": "relative",
                "code": `<div class="mask-add mask-image[url(/img/circle.png),url(/img/circle.png)] bg-image-[url(/img/mountains.jpg)]"></div>
<div class="mask-subtract mask-image[url(/img/circle.png),url(/img/circle.png)] bg-image-[url(/img/mountains.jpg)]"></div>
<div class="mask-intersect mask-image[url(/img/circle.png),url(/img/circle.png)] bg-image-[url(/img/mountains.jpg)]"></div>
<div class="mask-exclude mask-image[url(/img/circle.png),url(/img/circle.png)] bg-image-[url(/img/mountains.jpg)]"></div>`
            }
        }
    ]
};

export default maskComposite;